import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/mystery-box/Index.vue')
const Record = () => import('../activity/mystery-box/Record.vue')

export const indexRoute: RouteConfig = {
  path: '/mystery-box',
  name: 'mystery_box',
  component: Index,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '运动秀盲盒',
  },
}

export const recordRoute: RouteConfig = {
  path: '/mystery-box-record',
  name: 'mystery_box_record',
  component: Record,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '抽取记录',
  },
}

export default [indexRoute, recordRoute]
